import { render, staticRenderFns } from "./WsExpertsSearch.vue?vue&type=template&id=12db8022"
import script from "./WsExpertsSearch.vue?vue&type=script&lang=js"
export * from "./WsExpertsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports